import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  HiUser,
  HiEnvelope,
  HiIdentification,
  HiBanknotes,
  HiShieldCheck,
  HiPencilSquare,
  HiTrash,
} from "react-icons/hi2";

import classes from "./Account.module.css";
import { alertActions } from "../../store/alert-slice";
import { deleteAccount } from "../../api/api";
import Spinner from "../UI/Spinner";
import { getAuthToken } from "../../util/authToken";

const Account = (props) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const status = props.status ? "Active" : "Blocked";

  const deleteHandler = async () => {
    setShowSpinner(true);
    const res = await deleteAccount(getAuthToken(), props.id);
    if (!res) {
      dispatch(
        alertActions.setState({
          message: "Account deleted successfully",
          status: "success",
        })
      );
      navigate("/accounts");
    } else {
      dispatch(
        alertActions.setState({ message: res.message, status: "error" })
      );
    }
    setShowSpinner(false);
  };

  return (
    <motion.article
      className={classes.card}
      layout
      whileHover={{ y: -3 }}
      transition={{ type: "spring", stiffness: 400, damping: 28 }}
    >
      {showSpinner && <Spinner />}
      <div className={classes.photo}>
        <img src={props.photo} alt="" />
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiUser className={classes.rowIcon} aria-hidden />
          Name
        </span>
        <span>{props.name}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiIdentification className={classes.rowIcon} aria-hidden />
          Username
        </span>
        <span>{props.username}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiEnvelope className={classes.rowIcon} aria-hidden />
          Email
        </span>
        <span>{props.email}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiIdentification className={classes.rowIcon} aria-hidden />
          Account
        </span>
        <span>{props.account}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiBanknotes className={classes.rowIcon} aria-hidden />
          Balance
        </span>
        <span>Є{props.balance.toFixed(2)}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiShieldCheck className={classes.rowIcon} aria-hidden />
          Status
        </span>
        <span
          className={
            props.status ? classes.statusActive : classes.statusBlocked
          }
        >
          {status}
        </span>
      </div>
      <div className={classes.actions}>
        <Link to={`/accounts/update/${props.id}`}>
          <HiPencilSquare className={classes.actionIcon} aria-hidden />
          Update
        </Link>
        <button type="button" onClick={deleteHandler}>
          <HiTrash className={classes.actionIcon} aria-hidden />
          Delete
        </button>
      </div>
    </motion.article>
  );
};

export default Account;
